import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsCashAndRepairAuthenticationService } from '../../services/third-parts-cash-and-repair-authentication.service';


@Component({
  selector: 'app-cash-and-repair-accounting-entries-api-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatIconModule,
    MatSelectModule
  ],
  templateUrl: './cash-and-repair-ae-api-exporter-configuration.component.html',
  styleUrls: ['./cash-and-repair-ae-api-exporter-configuration.component.scss']
})
export class CashAndRepairAccountingEntriesApiExporterConfigurationComponent {
  formGroup: FormGroup;

  connectionsOptions$?: Observable<ThirdPartsAuthenticationList[]>;

  constructor(
    readonly fb: FormBuilder,
    protected readonly authenticationService: ThirdPartsCashAndRepairAuthenticationService,

  ) {
    this.formGroup = fb.group({
      authenticationId: [null, Validators.required]
    });

    this.connectionsOptions$ = this.authenticationService.list$();
  }
}